import {
  AGRICULTURE_AND_AQUACULTURE_LEVEL_1_THREAT_ID,
  BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
  NATURAL_SYSTEM_MODIFICATIONS_LEVEL_1_THREAT_ID,
  INVASIVE_AND_OTHER_PROBLEMATIC_SPECIES_LEVEL_1_THREAT_ID,
  POLLUTION_LEVEL_1_THREAT_ID
} from './levelOneThreats'

import {
  ANNUAL_AND_PERENNIAL_NON_TIMBER_CROPS_LEVEL_2_THREAT_ID,
  WOOD_AND_PULP_PLANTATIONS_LEVEL_2_THREAT_ID,
  LIVESTOCK_FARMING_AND_RANCHING_LEVEL_2_THREAT_ID,
  MARINE_AND_FRESHWATER_AQUACULTURE_LEVEL_2_THREAT_ID,
  HUNTING_AND_COLLECTING_TERRESTRIAL_ANIMALS_LEVEL_2_THREAT_ID,
  GATHERING_TERRESTRIAL_PLANTS_LEVEL_2_THREAT_ID,
  LOGGING_AND_WOOD_HARVESTING_LEVEL_2_THREAT_ID,
  FISHING_AND_HARVESTING_AQUATIC_RESOURCES_LEVEL_2_THREAT_ID,
  FIRE_AND_FIRE_SUPPRESSION_LEVEL_2_THREAT_ID,
  DAMS_AND_WATER_MANAGEMENT_LEVEL_2_THREAT_ID,
  INVASIVE_NON_NATIVE_ALIEN_SPECIES_DISEASES_LEVEL_2_THREAT_ID,
  PROBLEMATIC_NATIVE_SPECIES_DISEASES_LEVEL_2_THREAT_ID,
  PROBLEMATIC_SPECIES_DISEASES_OF_UNKNOWN_ORIGIN_LEVEL_2_THREAT_ID,
  VIRAL_PRION_INDUCED_DISEASES_LEVEL_2_THREAT_ID,
  DOMESTIC_AND_URBAN_WASTE_WATER_LEVEL_2_THREAT_ID,
  INDUSTRIAL_AND_MILITARY_EFFLUENTS_LEVEL_2_THREAT_ID,
  AGRICULTURAL_AND_FORESTRY_EFFLUENTS_LEVEL_2_THREAT_ID,
  AIR_BORNE_POLLUTANTS_LEVEL_2_THREAT_ID,
  EXCESS_ENERGY_LEVEL_2_THREAT_ID
} from './levelTwoThreats'

export const SHIFTING_AGRICULTURE_LEVEL_3_THREAT_ID = 1
export const SMALL_HOLDER_FARMING_LEVEL_3_THREAT_ID = 2
export const AGRO_INDUSTRY_FARMING_LEVEL_3_THREAT_ID = 3
export const SCALE_UNKNOWN_NON_TIMBER_CROPS_LEVEL_3_THREAT_ID = 4
export const SMALL_HOLDER_PLANTATIONS_LEVEL_3_THREAT_ID = 5
export const AGRO_INDUSTRY_PLANTATIONS_LEVEL_3_THREAT_ID = 6
export const SCALE_UNKNOWN_LEVEL_3_THREAT_ID = 7

export const level3Threats = [
  {
    id: SHIFTING_AGRICULTURE_LEVEL_3_THREAT_ID,
    name: 'Shifting agriculture',
    Level1ThreatId: AGRICULTURE_AND_AQUACULTURE_LEVEL_1_THREAT_ID,
    Level2ThreatId: ANNUAL_AND_PERENNIAL_NON_TIMBER_CROPS_LEVEL_2_THREAT_ID
  },
  {
    id: SMALL_HOLDER_FARMING_LEVEL_3_THREAT_ID,
    name: 'Small-holder farming',
    Level1ThreatId: AGRICULTURE_AND_AQUACULTURE_LEVEL_1_THREAT_ID,
    Level2ThreatId: ANNUAL_AND_PERENNIAL_NON_TIMBER_CROPS_LEVEL_2_THREAT_ID
  },
  {
    id: AGRO_INDUSTRY_FARMING_LEVEL_3_THREAT_ID,
    name: 'Agro-industry farming',
    Level1ThreatId: AGRICULTURE_AND_AQUACULTURE_LEVEL_1_THREAT_ID,
    Level2ThreatId: ANNUAL_AND_PERENNIAL_NON_TIMBER_CROPS_LEVEL_2_THREAT_ID
  },
  {
    id: SCALE_UNKNOWN_NON_TIMBER_CROPS_LEVEL_3_THREAT_ID,
    name: 'Scale Unknown/Unrecorded',
    Level1ThreatId: AGRICULTURE_AND_AQUACULTURE_LEVEL_1_THREAT_ID,
    Level2ThreatId: ANNUAL_AND_PERENNIAL_NON_TIMBER_CROPS_LEVEL_2_THREAT_ID
  },
  {
    id: SMALL_HOLDER_PLANTATIONS_LEVEL_3_THREAT_ID,
    name: 'Small-holder plantations',
    Level1ThreatId: AGRICULTURE_AND_AQUACULTURE_LEVEL_1_THREAT_ID,
    Level2ThreatId: WOOD_AND_PULP_PLANTATIONS_LEVEL_2_THREAT_ID
  },
  {
    id: AGRO_INDUSTRY_PLANTATIONS_LEVEL_3_THREAT_ID,
    name: 'Agro-industry plantations',
    Level1ThreatId: AGRICULTURE_AND_AQUACULTURE_LEVEL_1_THREAT_ID,
    Level2ThreatId: WOOD_AND_PULP_PLANTATIONS_LEVEL_2_THREAT_ID
  },
  {
    id: SCALE_UNKNOWN_LEVEL_3_THREAT_ID,
    name: 'Scale Unknown/Unrecorded',
    Level1ThreatId: AGRICULTURE_AND_AQUACULTURE_LEVEL_1_THREAT_ID,
    Level2ThreatId: WOOD_AND_PULP_PLANTATIONS_LEVEL_2_THREAT_ID
  },
  {
    id: 8,
    name: 'Nomadic grazing',
    Level1ThreatId: AGRICULTURE_AND_AQUACULTURE_LEVEL_1_THREAT_ID,
    Level2ThreatId: LIVESTOCK_FARMING_AND_RANCHING_LEVEL_2_THREAT_ID
  },
  {
    id: 9,
    name: 'Small-holder grazing, ranching or farming',
    Level1ThreatId: AGRICULTURE_AND_AQUACULTURE_LEVEL_1_THREAT_ID,
    Level2ThreatId: LIVESTOCK_FARMING_AND_RANCHING_LEVEL_2_THREAT_ID
  },
  {
    id: 10,
    name: 'Agro-industry grazing, ranching or farming',
    Level1ThreatId: AGRICULTURE_AND_AQUACULTURE_LEVEL_1_THREAT_ID,
    Level2ThreatId: LIVESTOCK_FARMING_AND_RANCHING_LEVEL_2_THREAT_ID
  },
  {
    id: 11,
    name: 'Scale Unknown/Unrecorded',
    Level1ThreatId: AGRICULTURE_AND_AQUACULTURE_LEVEL_1_THREAT_ID,
    Level2ThreatId: LIVESTOCK_FARMING_AND_RANCHING_LEVEL_2_THREAT_ID
  },
  {
    id: 12,
    name: 'Subsistence/artisinal aquaculture',
    Level1ThreatId: AGRICULTURE_AND_AQUACULTURE_LEVEL_1_THREAT_ID,
    Level2ThreatId: MARINE_AND_FRESHWATER_AQUACULTURE_LEVEL_2_THREAT_ID
  },
  {
    id: 13,
    name: 'Industrial aquaculture',
    Level1ThreatId: AGRICULTURE_AND_AQUACULTURE_LEVEL_1_THREAT_ID,
    Level2ThreatId: MARINE_AND_FRESHWATER_AQUACULTURE_LEVEL_2_THREAT_ID
  },
  {
    id: 14,
    name: 'Scale Unknown/Unrecorded',
    Level1ThreatId: AGRICULTURE_AND_AQUACULTURE_LEVEL_1_THREAT_ID,
    Level2ThreatId: MARINE_AND_FRESHWATER_AQUACULTURE_LEVEL_2_THREAT_ID
  },
  {
    id: 15,
    name: 'Intentional use (species being assessed is the target)',
    Level1ThreatId: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
    Level2ThreatId: HUNTING_AND_COLLECTING_TERRESTRIAL_ANIMALS_LEVEL_2_THREAT_ID
  },
  {
    id: 16,
    name: 'Unintentional effects (species being assessed is not the target)',
    Level1ThreatId: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
    Level2ThreatId: HUNTING_AND_COLLECTING_TERRESTRIAL_ANIMALS_LEVEL_2_THREAT_ID
  },
  {
    id: 17,
    name: 'Persecution/control',
    Level1ThreatId: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
    Level2ThreatId: HUNTING_AND_COLLECTING_TERRESTRIAL_ANIMALS_LEVEL_2_THREAT_ID
  },
  {
    id: 18,
    name: 'Motivation Unknown/Unrecorded',
    Level1ThreatId: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
    Level2ThreatId: HUNTING_AND_COLLECTING_TERRESTRIAL_ANIMALS_LEVEL_2_THREAT_ID
  },
  {
    id: 19,
    name: 'Intentional use (species being assessed is the target)', // duplicate
    Level1ThreatId: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
    Level2ThreatId: GATHERING_TERRESTRIAL_PLANTS_LEVEL_2_THREAT_ID
  },
  {
    id: 20,
    name: 'Unintentional effects (species being assessed is not the target)', // duplicate
    Level1ThreatId: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
    Level2ThreatId: GATHERING_TERRESTRIAL_PLANTS_LEVEL_2_THREAT_ID
  },
  {
    id: 21,
    name: 'Persecution/control', // duplicate
    Level1ThreatId: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
    Level2ThreatId: GATHERING_TERRESTRIAL_PLANTS_LEVEL_2_THREAT_ID
  },
  {
    id: 22,
    name: 'Motivation Unknown/Unrecorded', // duplicate
    Level1ThreatId: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
    Level2ThreatId: GATHERING_TERRESTRIAL_PLANTS_LEVEL_2_THREAT_ID
  },
  {
    id: 23,
    name: 'Intentional use: subsistence/small scale (species being assessed is the target) [harvest]', // duplicate
    Level1ThreatId: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
    Level2ThreatId: LOGGING_AND_WOOD_HARVESTING_LEVEL_2_THREAT_ID
  },
  {
    id: 24,
    name: 'Intentional use: large scale (species being assessed is the target) [harvest]', // duplicate
    Level1ThreatId: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
    Level2ThreatId: LOGGING_AND_WOOD_HARVESTING_LEVEL_2_THREAT_ID
  },
  {
    id: 25,
    name: 'Unintentional effects: subsistence/small scale (species being assessed is not the target) [harvest]', // duplicate
    Level1ThreatId: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
    Level2ThreatId: LOGGING_AND_WOOD_HARVESTING_LEVEL_2_THREAT_ID
  },
  {
    id: 26,
    name: 'Unintentional effects: large scale (species being assessed is not the target) [harvest]', // duplicate
    Level1ThreatId: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
    Level2ThreatId: LOGGING_AND_WOOD_HARVESTING_LEVEL_2_THREAT_ID
  },
  {
    id: 27,
    name: 'Motivation Unknown/Unrecorded', // duplicate
    Level1ThreatId: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
    Level2ThreatId: LOGGING_AND_WOOD_HARVESTING_LEVEL_2_THREAT_ID
  },
  {
    id: 28,
    name: 'Intentional use: subsistence/small scale (species being assessed is the target) [harvest]', // duplicate
    Level1ThreatId: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
    Level2ThreatId: FISHING_AND_HARVESTING_AQUATIC_RESOURCES_LEVEL_2_THREAT_ID
  },
  {
    id: 29,
    name: 'Intentional use: large scale (species being assessed is the target) [harvest]', // duplicate
    Level1ThreatId: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
    Level2ThreatId: FISHING_AND_HARVESTING_AQUATIC_RESOURCES_LEVEL_2_THREAT_ID
  },
  {
    id: 30,
    name: 'Unintentional effects: subsistence/small scale (species being assessed is not the target) [harvest]', // duplicate
    Level1ThreatId: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
    Level2ThreatId: FISHING_AND_HARVESTING_AQUATIC_RESOURCES_LEVEL_2_THREAT_ID
  },
  {
    id: 31,
    name: 'Unintentional effects: large scale (species being assessed is not the target) [harvest]', // duplicate
    Level1ThreatId: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
    Level2ThreatId: FISHING_AND_HARVESTING_AQUATIC_RESOURCES_LEVEL_2_THREAT_ID
  },
  {
    id: 32,
    name: 'Persecution/control', // duplicate
    Level1ThreatId: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
    Level2ThreatId: FISHING_AND_HARVESTING_AQUATIC_RESOURCES_LEVEL_2_THREAT_ID
  },
  {
    id: 33,
    name: 'Motivation Unknown/Unrecorded', // duplicate
    Level1ThreatId: BIOLOGICAL_RESOURCE_USE_LEVEL_1_THREAT_ID,
    Level2ThreatId: FISHING_AND_HARVESTING_AQUATIC_RESOURCES_LEVEL_2_THREAT_ID
  },
  {
    id: 34,
    name: 'Increase in fire frequency/intensity',
    Level1ThreatId: NATURAL_SYSTEM_MODIFICATIONS_LEVEL_1_THREAT_ID,
    Level2ThreatId: FIRE_AND_FIRE_SUPPRESSION_LEVEL_2_THREAT_ID
  },
  {
    id: 35,
    name: 'Suppression in fire frequency/intensity',
    Level1ThreatId: NATURAL_SYSTEM_MODIFICATIONS_LEVEL_1_THREAT_ID,
    Level2ThreatId: FIRE_AND_FIRE_SUPPRESSION_LEVEL_2_THREAT_ID
  },
  {
    id: 36,
    name: 'Trend Unknown/Unrecorded',
    Level1ThreatId: NATURAL_SYSTEM_MODIFICATIONS_LEVEL_1_THREAT_ID,
    Level2ThreatId: FIRE_AND_FIRE_SUPPRESSION_LEVEL_2_THREAT_ID
  },
  {
    id: 37,
    name: 'Abstraction of surface water (domestic use)',
    Level1ThreatId: NATURAL_SYSTEM_MODIFICATIONS_LEVEL_1_THREAT_ID,
    Level2ThreatId: DAMS_AND_WATER_MANAGEMENT_LEVEL_2_THREAT_ID
  },
  {
    id: 38,
    name: 'Abstraction of surface water (commercial use)',
    Level1ThreatId: NATURAL_SYSTEM_MODIFICATIONS_LEVEL_1_THREAT_ID,
    Level2ThreatId: DAMS_AND_WATER_MANAGEMENT_LEVEL_2_THREAT_ID
  },
  {
    id: 39,
    name: 'Abstraction of surface water (agricultural use)',
    Level1ThreatId: NATURAL_SYSTEM_MODIFICATIONS_LEVEL_1_THREAT_ID,
    Level2ThreatId: DAMS_AND_WATER_MANAGEMENT_LEVEL_2_THREAT_ID
  },
  {
    id: 40,
    name: 'Abstraction of surface water (unknown use)',
    Level1ThreatId: NATURAL_SYSTEM_MODIFICATIONS_LEVEL_1_THREAT_ID,
    Level2ThreatId: DAMS_AND_WATER_MANAGEMENT_LEVEL_2_THREAT_ID
  },
  {
    id: 41,
    name: 'Abstraction of ground water (domestic use)',
    Level1ThreatId: NATURAL_SYSTEM_MODIFICATIONS_LEVEL_1_THREAT_ID,
    Level2ThreatId: DAMS_AND_WATER_MANAGEMENT_LEVEL_2_THREAT_ID
  },
  {
    id: 42,
    name: 'Abstraction of ground water (commercial use)',
    Level1ThreatId: NATURAL_SYSTEM_MODIFICATIONS_LEVEL_1_THREAT_ID,
    Level2ThreatId: DAMS_AND_WATER_MANAGEMENT_LEVEL_2_THREAT_ID
  },
  {
    id: 43,
    name: 'Abstraction of ground water (agricultural use)',
    Level1ThreatId: NATURAL_SYSTEM_MODIFICATIONS_LEVEL_1_THREAT_ID,
    Level2ThreatId: DAMS_AND_WATER_MANAGEMENT_LEVEL_2_THREAT_ID
  },
  {
    id: 44,
    name: 'Abstraction of ground water (unknown use)',
    Level1ThreatId: NATURAL_SYSTEM_MODIFICATIONS_LEVEL_1_THREAT_ID,
    Level2ThreatId: DAMS_AND_WATER_MANAGEMENT_LEVEL_2_THREAT_ID
  },
  {
    id: 45,
    name: 'Small dams',
    Level1ThreatId: NATURAL_SYSTEM_MODIFICATIONS_LEVEL_1_THREAT_ID,
    Level2ThreatId: DAMS_AND_WATER_MANAGEMENT_LEVEL_2_THREAT_ID
  },
  {
    id: 46,
    name: 'Large dams',
    Level1ThreatId: NATURAL_SYSTEM_MODIFICATIONS_LEVEL_1_THREAT_ID,
    Level2ThreatId: DAMS_AND_WATER_MANAGEMENT_LEVEL_2_THREAT_ID
  },
  {
    id: 47,
    name: 'Dams (size unknown)',
    Level1ThreatId: NATURAL_SYSTEM_MODIFICATIONS_LEVEL_1_THREAT_ID,
    Level2ThreatId: DAMS_AND_WATER_MANAGEMENT_LEVEL_2_THREAT_ID
  },
  {
    id: 48,
    name: 'Unspecified species', // DUPLICATE
    Level1ThreatId: INVASIVE_AND_OTHER_PROBLEMATIC_SPECIES_LEVEL_1_THREAT_ID,
    Level2ThreatId: INVASIVE_NON_NATIVE_ALIEN_SPECIES_DISEASES_LEVEL_2_THREAT_ID
  },
  {
    id: 49,
    name: 'Named species', // DUPLICATE
    Level1ThreatId: INVASIVE_AND_OTHER_PROBLEMATIC_SPECIES_LEVEL_1_THREAT_ID,
    Level2ThreatId: INVASIVE_NON_NATIVE_ALIEN_SPECIES_DISEASES_LEVEL_2_THREAT_ID
  },
  {
    id: 50,
    name: 'Unspecified species', // DUPLICATE
    Level1ThreatId: INVASIVE_AND_OTHER_PROBLEMATIC_SPECIES_LEVEL_1_THREAT_ID,
    Level2ThreatId: PROBLEMATIC_NATIVE_SPECIES_DISEASES_LEVEL_2_THREAT_ID
  },
  {
    id: 51,
    name: 'Named species', // DUPLICATE
    Level1ThreatId: INVASIVE_AND_OTHER_PROBLEMATIC_SPECIES_LEVEL_1_THREAT_ID,
    Level2ThreatId: PROBLEMATIC_NATIVE_SPECIES_DISEASES_LEVEL_2_THREAT_ID
  },
  {
    id: 52,
    name: 'Unspecified species', // DUPLICATE
    Level1ThreatId: INVASIVE_AND_OTHER_PROBLEMATIC_SPECIES_LEVEL_1_THREAT_ID,
    Level2ThreatId: PROBLEMATIC_SPECIES_DISEASES_OF_UNKNOWN_ORIGIN_LEVEL_2_THREAT_ID
  },
  {
    id: 53,
    name: 'Named species', // DUPLICATE
    Level1ThreatId: INVASIVE_AND_OTHER_PROBLEMATIC_SPECIES_LEVEL_1_THREAT_ID,
    Level2ThreatId: PROBLEMATIC_SPECIES_DISEASES_OF_UNKNOWN_ORIGIN_LEVEL_2_THREAT_ID
  },
  {
    id: 54,
    name: 'Unspecified species', // DUPLICATE
    Level1ThreatId: INVASIVE_AND_OTHER_PROBLEMATIC_SPECIES_LEVEL_1_THREAT_ID,
    Level2ThreatId: VIRAL_PRION_INDUCED_DISEASES_LEVEL_2_THREAT_ID
  },
  {
    id: 55,
    name: 'Named species', // DUPLICATE
    Level1ThreatId: INVASIVE_AND_OTHER_PROBLEMATIC_SPECIES_LEVEL_1_THREAT_ID,
    Level2ThreatId: VIRAL_PRION_INDUCED_DISEASES_LEVEL_2_THREAT_ID
  },
  {
    id: 56,
    name: 'Sewage',
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    Level2ThreatId: DOMESTIC_AND_URBAN_WASTE_WATER_LEVEL_2_THREAT_ID
  },
  {
    id: 57,
    name: 'Run-off',
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    Level2ThreatId: DOMESTIC_AND_URBAN_WASTE_WATER_LEVEL_2_THREAT_ID
  },
  {
    id: 58,
    name: 'Type Unknown/Unrecorded', // DUPLICATE
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    Level2ThreatId: DOMESTIC_AND_URBAN_WASTE_WATER_LEVEL_2_THREAT_ID
  },
  {
    id: 59,
    name: 'Oil spills',
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    Level2ThreatId: INDUSTRIAL_AND_MILITARY_EFFLUENTS_LEVEL_2_THREAT_ID
  },
  {
    id: 60,
    name: 'Seepage from mining',
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    Level2ThreatId: INDUSTRIAL_AND_MILITARY_EFFLUENTS_LEVEL_2_THREAT_ID
  },
  {
    id: 61,
    name: 'Type Unknown/Unrecorded', // DUPLICATE
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    Level2ThreatId: INDUSTRIAL_AND_MILITARY_EFFLUENTS_LEVEL_2_THREAT_ID
  },
  {
    id: 62,
    name: 'Nutrient loads',
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    Level2ThreatId: AGRICULTURAL_AND_FORESTRY_EFFLUENTS_LEVEL_2_THREAT_ID
  },
  {
    id: 63,
    name: 'Soil erosion, sedimentation',
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    Level2ThreatId: AGRICULTURAL_AND_FORESTRY_EFFLUENTS_LEVEL_2_THREAT_ID
  },
  {
    id: 64,
    name: 'Herbicides and pesticides',
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    Level2ThreatId: AGRICULTURAL_AND_FORESTRY_EFFLUENTS_LEVEL_2_THREAT_ID
  },
  {
    id: 65,
    name: 'Type Unknown/Unrecorded', // DUPLICATE
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    Level2ThreatId: AGRICULTURAL_AND_FORESTRY_EFFLUENTS_LEVEL_2_THREAT_ID
  },
  {
    id: 66,
    name: 'Acid rain',
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    Level2ThreatId: AIR_BORNE_POLLUTANTS_LEVEL_2_THREAT_ID
  },
  {
    id: 67,
    name: 'Smog',
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    Level2ThreatId: AIR_BORNE_POLLUTANTS_LEVEL_2_THREAT_ID
  },
  {
    id: 68,
    name: 'Ozone',
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    Level2ThreatId: AIR_BORNE_POLLUTANTS_LEVEL_2_THREAT_ID
  },
  {
    id: 69,
    name: 'Type Unknown/Unrecorded', // DUPLICATE
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    Level2ThreatId: AIR_BORNE_POLLUTANTS_LEVEL_2_THREAT_ID
  },
  {
    id: 70,
    name: 'Light pollution',
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    Level2ThreatId: EXCESS_ENERGY_LEVEL_2_THREAT_ID
  },
  {
    id: 71,
    name: 'Thermal pollution',
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    Level2ThreatId: EXCESS_ENERGY_LEVEL_2_THREAT_ID
  },
  {
    id: 72,
    name: 'Noise pollution',
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    Level2ThreatId: EXCESS_ENERGY_LEVEL_2_THREAT_ID
  },
  {
    id: 73,
    name: 'Type Unknown/Unrecorded', // DUPLICATE
    Level1ThreatId: POLLUTION_LEVEL_1_THREAT_ID,
    Level2ThreatId: EXCESS_ENERGY_LEVEL_2_THREAT_ID
  }
]
